import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/icons/document/document-file-music-line/document-file-music-line.component.js'

const tagName = 'dap-ds-icon-file-music-line'

/**
 * `dap-ds-icon-file-music-line`
 * @summary An icon
 * @element dap-ds-icon-file-music-line
 * @title - DocumentFileMusicLine
 * @group icon
 * @icontype document
 *
 * @attribute {number} size - (optional) The width and height in pixels
 * @attribute {boolean} selected - (optional) Sets the icon color via the `fill` attribute
 * @attribute {string} accessibilityTitle - (optional) When using the icon standalone, make it meaningful for accessibility
 * @attribute {boolean} focusable - (optional) If `true` the icon can receive focus
 *
 * @csspart base - The main icon container.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DocumentFileMusicLine',
})

export default reactWrapper
